import { create } from 'zustand';
import { phoneModes } from '../constants/phone.constants';
import { PhoneStoreStates, PhoneStoreType } from '../types/store/phone.types';

const defaultValues: PhoneStoreStates = {
  isOpen: true,
  isPopupView: true,
  mode: phoneModes.dialer,
  isMinimized: false,
  drawerType: null,
  isMuted: false,
  tagMode: null,
  isIncoming: false,
  isOpenRejectedMessage: false,
  isUnmuteMicCanceled: false,
  memberCallId: null,
  isQueuePanelOpen: false,
};

export const usePhoneStore = create<PhoneStoreType>((set) => ({
  ...defaultValues,
  openDialer: () => set({ isOpen: true, isPopupView: false, mode: phoneModes.dialer }),
  openIncomingPhone: (isMinimized = true, memberCallId = undefined) =>
    set({
      isOpen: true,
      isPopupView: false,
      mode: phoneModes.incoming,
      isMinimized,
      memberCallId: memberCallId ?? null,
    }),
  openPhoneInCallMode: () => set({ isOpen: true, isPopupView: false, mode: phoneModes.inCall }),
  openTransferCall: () => set({ mode: phoneModes.transferCall, isMinimized: false }),
  closeTransferCall: () => set({ mode: phoneModes.inCall, isMinimized: false }),
  closePhone: () => set({ isOpen: false }),
  minimizePhone: () => set({ isMinimized: true }),
  maximizePhone: () => set({ isMinimized: false }),
  setPopupView: (isPopupView: boolean) => set({ isPopupView }),
  openDrawer: (drawerType) => set({ drawerType }),
  closeDrawer: () => set({ drawerType: null }),
  toggleMute: (isMuted) => set({ isMuted }),
  resetPhone: () => set({ ...defaultValues, isOpen: false }),
  resetPhoneKeepOpen: () =>
    set((state) => ({
      ...defaultValues,
      isOpen: true,
      isPopupView: false,
      mode: phoneModes.dialer,
      isQueuePanelOpen: state.isQueuePanelOpen,
    })),
  setTagMode: (tagMode) => set({ tagMode }),
  setIsIncoming: (isIncoming) => set({ isIncoming }),
  setIsOpenRejectedMessage: (isOpenRejectedMessage) => set({ isOpenRejectedMessage }),
  setIsUnmuteMicCanceled: (isUnmuteMicCanceled: boolean) => set({ isUnmuteMicCanceled }),
  setMemberCallId: (memberId) => set({ memberCallId: memberId + '' }),
  toggleQueuePanel: () => set((state) => ({ isQueuePanelOpen: !state.isQueuePanelOpen })),
  closeQueuePanel: () => set({ isQueuePanelOpen: false }),
  openQueuePanel: () => set({ isQueuePanelOpen: true }),
}));
